<template>
  <div class='popular'>
    <div class="box">
      <div class="title">
          六西格玛为什么退流行？因为成功是无法复刻的！
        </div>
        <div class="author">
          作者：Jay from 捷思企业管理顾问(深圳)有限公司
        </div>
        <div class="headImg">
          <img :src="headImgUrl" alt="">
        </div>
        <div class="note">
          <div class="text">
            <span>任何人或组织的成功，都是无法被完全复制的！因为每个人或组织所处的环境和条件都不一样，迈向成功的过程中亦经历了许多选择，才走至今日的局面，</span>
            <span class="fontBold">每个成功的案例都是独一无二的，能复制那就不伟大了。</span>
            <span>六西格玛因世纪CEO威尔奇而戴上光环，反之，就算没有六西格玛，威尔奇当然也会寻求其他方法，通用电气依然会迈向巅峰，威尔奇依然会伟大。</span>
          </div>
          <div class="text">
            <span>举另一个经典的成功案例，丰田汽车于2007年打败通用汽车，夺得全球汽车销量冠军(注)，一举让</span>
            <span class="fontBold">精益生产Lean production</span>
            <span>(或称丰田生产模式Toyota production system, TPS) 成为全球企业追捧的当代显学！早在1985年美国学者就已经在研究日本汽车业的成功秘诀，并于1990年出版了经典著作”改变世界的机器”，「精益(Lean)」一词亮相于世人面前，后续并衍生出精益服务、精益设计、精益物流等一系列的精益管理哲学。</span>
          </div>
          <div class="text">
            <span>二战后，丰田汽车体认到在缺乏资源、生产力远不如美国的日本，若也学美国汽车业用规模经济的大批量生产，一定是竞争不过美国的，所以得另辟丰田汽车的生存之道。经过反复的摸索和发展，逐渐地形成以JIT(Just ing time)和自働化为两大支柱的丰田生产模式。同时，质量大师戴明亦于战后将当时最新的统计质量控制观念带至日本，以及经过日本质量学者们的努力，相继产生了全公司质量管理(CWQC)、ＱＣ七大手法、品管圈(QCC)、田口质量工程等质量管理方法，加上日本人的团队、专注等特质，使日本产品的质量水平达到美国企业望尘莫及的地步。美国NBC电台于1980年拍摄了一部纪录片，名称为「日本能，为什么我们不能」，反思美国产品质量不如日本的原因。</span>
          </div>
          <div class="text">
            <span>从这个例子我们可以得知，</span>
            <span class="fontBold">精益生产(TPS)是丰田汽车体认其环境和条件，拟定符合其自身发展方针的战略，经年累月努力所形成的。并不是因为丰田导入了一套名为「精益」的管理方法，而成为今日的丰田。</span>
            <span>所以企业在学习精益时，得弄清楚它的精髓，并考虑自身的环境、条件和产业特性等，拟定适合的战略，而不是依样画葫芦。经常看到企业在导入精益生产时，着重在学丰田的「形」，像是看板拉式生产、安灯、U型生产线等，而没深思人家的「神」，所以在车间改变一下流水线的型态，装了目视化的看板、灯号后，宣称我们有导入精益生产。</span>
          </div>
          <div class="text">
            <span>回头来谈六西格玛，导入新的管理理论要考虑的面向很多。我们公司有没有通用电气那样的实力？人力素质跟得上吗？我们想透过导入六西格玛达成什么目的、目标？跟企业使命、愿景相符吗？美国、中国的文化差异会有影响吗？等等的问题，书本、老师、顾问教的是原汁原味的美式六西格玛，原封不动地搬到中国能一样有效吗？甚至欧美一些企业导六西格玛也是只得其形，不得其神(威尔奇在其自传中有提到)。</span>
          </div>
          <div class="text">
            <span>所以六西格玛退流行是可预见的，因为一开始就没站在合理的出发点！企业盈利不错时就跟风导一下六西格玛，竞争压力大时，这种花钱的活动就会被优先砍掉。六西格玛自始至终都没啥问题，反映出结果的是使用者的理解和心态，有洞悉力的领导者可能早就将六西格玛精髓融入其企业文化中了。所以要我来说</span>
            <span class="fontBold">六西格玛也没啥退不退流行，只是回归本质！</span>
            <span>运用之妙，存乎一心，懂的人自然知道如何去运用六西格玛来走出自己的道，一般人就姑且把它当作是一场游戏一场梦！</span>
          </div>
          <div class="text">
            <span>注：丰田汽车于2007年打败通用汽车，夺得全球汽车销量冠军，直到2016年才被大众汽车超越，之间只有2011年没在冠军宝座(当年日本发生311大地震和大海啸)，到了2020年丰田又再次登顶。</span>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {
  },
  data () {
    return {
      headImgUrl: require('../../assets/img/article1.png')
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.popular{
  text-align: center;
  text-justify: newspaper;
  text-align: justify;
  margin-bottom: 4rem;
  font-size: 24px;
  line-height: 48px;
}
.popular .box{
  width: 90%;
}
.popular .box{
  margin: 0 auto;
}
.popular .box .title{
  font-weight: bold;
  font-size: 34px;
  margin: 16px 0px;
}
.popular .box .author{
  margin: 16px 0px;
  font-size: 16px;
}
.popular .box .note{
  text-indent: 2em;
}
.popular .box .note .text{
  margin-top: 40px;
}
@media screen and (max-width: 1200px){
}
@media screen and (max-width: 992px){
  .popular{
    font-size: 20px;
  }
  .popular .box .title{
    font-size: 30px;
  }
}
@media screen and (max-width: 767px){
}
@media screen and (max-width: 450px){
  .popular .box .author{
    font-size: 12px;
  }
  .popular{
    font-size: 16px;
    line-height: 32px;
  }
    .popular .box .title{
    font-size: 24px;
  }
  .popular .box .note .text{
    margin-top: 20px;
  }
}
</style>
